export default "__VITE_ASSET__DULLjB$L__"